import styled from 'styled-components';


export const Product = styled.div`
  position: relative;
  margin-bottom: 0;
  overflow: hidden;

  .productTitle {
    font-size: 16px;
    margin-bottom: 20px;
    line-height: 1.2;

    a {
      text-decoration: none;
    }

    @media ${({ theme }) => theme.breakpoints.tablet} {
      font-size: 14px;
    }

    @media ${({ theme }) => theme.breakpoints.mobile} {
      margin: 0 0 5px;
      font-size: 14px;
    }
  }

  .sticker,
  .stickerInline {
    display: block;
  }

  .offerSaving {
    display: inline;
    position: static;
  }

  .compare {
    left: 0;

    input {
      display: none;
    }
  }

  .desc:before {
    font-size: 1.2em;
    line-height: 1;
    font-family: dcg-icons;
    content: '\f054';
    color: #999;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -0.6em;
  }

  .currentPrice {
    font-size: 1.24em;
  }

  .sticker,
  .offerSaving {
    font-size: 0.88em;
  }

  .productPitch {
    color: #333 !important;

    * {
      font-style: normal !important;
      font-size: 1em !important;
      color: #333 !important;
    }

    p:last-child {
      margin: 0;
    }
  }

  .badges {
    display: inline-block;

    margin-top: 10px;
    text-align: center;

    a {
      display: inline-block;
      margin: 0 2px;

      img {
        display: block;
      }
    }

    img {
      max-height: 48px;
      width: auto;
    }
  }

  .currentPrice,
  .currentPrice ins {
    font-weight: bold;
    background: none;
    color: #cb003a;
    line-height: 1;
  }

  .currentPrice {
    font-size: 1.4em;
  }

  .previousPrice {
    color: #666;

    del {
      text-decoration: none;
    }

    span {
      display: inline-block;
    }
  }

  .previousPrice,
  .availability {
    font-size: 0.88em;
    color: #666;

    span,
    i {
      display: inline-block;
      margin-right: 5px;
    }

    i {
      font-size: 16px;
    }

    .unavailable i {
      color: #ccc;
    }

    .available i {
      color: green;
    }

    .unavailable {
      &.email-when-back {
        color: #161b7a;

        i {
          color: #161b7a;
        }
      }
    }
  }

  .availability {
    clear: left;
    float: none;
    display: block;
    margin: 0.25em 0;
    font-weight: bold;
    color: #999;
  }

  .offerSaving {
    color: #161b7a;
    font-weight: bold;
  }

  .productDescription {
    li {
      display: list-item !important;
      margin-bottom: 0;

      i {
        font-size: 18px;
        margin-top: -4px;
      }
    }
  }

  .longDescControler {
    display: inline-block;
  }

  .compare {
    top: 0;
    position: absolute;
  }
}

.resultList,
#recommended-products,
#compare-popup-section {
  .amounts .main-amount .price {
    font-size: 18px;
  }

  .amounts .main-amount .saving {
    font-size: 14px;
    padding: 0 1em;
  }

  .amounts.prd-oos .main-amount {
    .price,
    .saving,
    .per-month {
      color: #a9a9a9;
    }
  }

  .amounts .past-amount {
    span {
      font-size: 9px;
    }
  }

  .prd-channels {
    li {
      font-weight: normal;
      min-height: 20px;
      line-height: 20px;

      @media ${({ theme }) => theme.breakpoints.mobile} {
        font-size: 14px;
      }

      i {
        font-size: 24px;
        margin-top: -2px;
      }
    }
  }

`;
